import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { EventsTableHeaderStyle } from 'src/domains/sportsbook/webview/components/eventsTable/EventsMainSectionWrapper';
import { PromotedSportSingleType } from 'src/domains/layouts/webview/components/promotedSports/PromotedEventsState.state';
import { PromotedSportSectionWrapper } from 'src/domains/layouts/webview/components/promotedSports/PromotedSportSectionWrapper';
import { FiltersStyle } from 'src/domains/sportsbook/webview/components/eventsTable/EventsTable.style';
import { FiltersScrollableWrapper } from 'src/domains/layouts/webview/components/filters/FiltersScrollableWrapper';
import { Filter } from 'src/domains/layouts/webview/components/filters/Filters.style';
import { UniverseComponent } from 'src/domains/common/universes';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { Collapse } from 'src/ui/components/collapse/sports/01/Collapse';
import { PromotedEventsWrapper, PromotedSportsWrapper } from './PromotedEventsWidget.style';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { AppLayoutsState } from 'src/domains/layouts/state/AppLayouts.state';

interface PropsType {
    topMargin?: boolean;
}

export const PromotedEventsWidget = observer('PromotedEventsWidget', ({ topMargin = false }: PropsType) => {
    const common = useCommon();
    const { promotedEventsState } = AppLayoutsState.get(common);

    const promotedSports = promotedEventsState.promotedSportsToShow;
    const configState = ConfigComponents.get(common).config;

    const titleJsx = (
        <UniverseComponent>
            {(universe): React.ReactElement => (
                <span>{universe.promotedEventsSectionTitle(LanguagesState.get(common))}</span>
            )}
        </UniverseComponent>
    );

    if (promotedSports.length > 0) {
        return (
            <PromotedEventsWrapper
                variant={configState.componentVariants.sportsbookVariant}
                topMargin={topMargin}
            >
                <Collapse
                    title={titleJsx}
                    isOpen={promotedEventsState.openEvents}
                    handleToggle={promotedEventsState.setOpenEvents}
                    dataTest='promoted-event-header'
                />
                {promotedEventsState.openEvents ? (
                    <>
                        <FiltersStyle
                            headerStyle={EventsTableHeaderStyle.SOLID}
                            isCompetitionPage={false}
                            variant={configState.componentVariants.sportsbookVariant}
                        >
                            <FiltersScrollableWrapper>
                                {promotedEventsState.sportFiltersAll.map((sport) => {
                                    const sportName = common.models.getSport(sport.key)?.name ?? '';
                                    return (
                                        <Filter
                                            key={sport.key}
                                            title={sport.key === 'all' ? 'All Sports' : sportName}
                                            disabled={false}
                                            skin='primary'
                                            onClick={(): void =>
                                                promotedEventsState.handleToggleIsSportFilterActive(sport.key)
                                            }
                                            isActive={promotedEventsState.isFilterActive(sport.key)}
                                            data-test={`promoted-event-filter-${sportName.toLowerCase().replaceAll(' ', '')}`}
                                            variant={configState.componentVariants.filtersVariant}
                                        >
                                            {sport.key === 'all' ? 'All Sports' : sportName}
                                        </Filter>
                                    );
                                })}
                            </FiltersScrollableWrapper>
                        </FiltersStyle>
                        <PromotedSportsWrapper variant={configState.componentVariants.sportsbookVariant}>
                            {promotedSports.map((sportData: PromotedSportSingleType) => (
                                <React.Fragment key={sportData.id}>
                                    {promotedEventsState.sportFiltersAll.map((elem) => {
                                        if (elem.key === sportData.sport_id && sportData.competitions_list.length > 0) {
                                            return (
                                                <PromotedSportSectionWrapper
                                                    key={sportData.id}
                                                    sportSlug={sportData.sport_id}
                                                    sportData={sportData}
                                                />
                                            );
                                        }
                                    })}
                                </React.Fragment>
                            ))}{' '}
                        </PromotedSportsWrapper>
                    </>
                ) : null}
            </PromotedEventsWrapper>
        );
    }

    return null;
});
